<span class="p-input-icon-left">
  <i class="pi pi-search icon"></i>
  <input type="text" pInputText class="p-2 pl-6 simple-input-width" [placeholder]="placeholder"
    [ngModel]="value" (keydown.enter)="onParentFunction($event)"  (ngModelChange)="onValueChange($event)">
</span>
